import { useContext } from "react";
import { a as uiKitContext } from "./useUiKitTheme-C9zsuTl3.js";
const useUiKitComponents = () => {
  const context = useContext(uiKitContext);
  if (context === null) {
    throw new Error(
      "data of UIKitProvider cannot be null, please add 'UIKitProvider' to the root of your application"
    );
  }
  return context.components;
};
export {
  useUiKitComponents as u
};
